import React from 'react';

const Certificate = ({ userName, courseTitle, date }) => {
  return (
    <div className="certificate-container p-8 bg-white border-[16px] border-double border-[#b8860b] shadow-2xl relative overflow-hidden" style={{ width: '800px', height: '600px', fontFamily: "'Playfair Display', serif" }}>
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{ backgroundImage: 'radial-gradient(#b8860b 1px, transparent 1px)', backgroundSize: '20px 20px' }} />
      
      {/* Corner Ornaments */}
      <div className="absolute top-4 left-4 w-12 h-12 border-t-4 border-l-4 border-[#b8860b]" />
      <div className="absolute top-4 right-4 w-12 h-12 border-t-4 border-r-4 border-[#b8860b]" />
      <div className="absolute bottom-4 left-4 w-12 h-12 border-b-4 border-l-4 border-[#b8860b]" />
      <div className="absolute bottom-4 right-4 w-12 h-12 border-b-4 border-r-4 border-[#b8860b]" />

      <div className="flex flex-col items-center justify-center h-full text-center px-12 relative z-10">
        <div className="mb-4">
          <span className="text-sm font-bold tracking-[0.3em] uppercase text-[#8b6508]">Certificate of Completion</span>
        </div>
        
        <h1 className="text-2xl font-bold text-gray-800 mb-2 uppercase tracking-tight">Market Mavericks Academy</h1>
        
        <div className="w-24 h-0.5 bg-[#b8860b] mb-8" />
        
        <p className="text-lg text-gray-600 italic mb-2">This is to certify that</p>
        
        <h2 className="text-4xl font-extrabold text-[#1a1a1a] mb-6 capitalize underline decoration-[#b8860b] decoration-2 underline-offset-8">
          {userName || 'Valued Learner'}
        </h2>
        
        <p className="text-lg text-gray-600 mb-8 max-w-md">
          has successfully completed the comprehensive course on
        </p>
        
        <h3 className="text-2xl font-bold text-[#b8860b] mb-12 uppercase tracking-wide">
          {courseTitle || 'Financial Market Mastery'}
        </h3>
        
        <div className="flex justify-between w-full px-8 mt-4">
          <div className="flex flex-col items-center">
            <div className="w-32 border-b border-gray-400 mb-2" />
            <span className="text-xs font-bold text-gray-500 uppercase">Authorized Signature</span>
          </div>
          
          <div className="relative">
             {/* Gold Seal */}
             <div className="w-20 h-20 bg-gradient-to-br from-[#ffd700] via-[#b8860b] to-[#8b6508] rounded-full flex items-center justify-center shadow-lg border-4 border-white/20">
                <div className="w-16 h-16 border-2 border-white/30 rounded-full flex items-center justify-center">
                  <span className="text-white font-black text-xl">MM</span>
                </div>
             </div>
             <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 whitespace-nowrap">
                <span className="text-[10px] font-bold text-[#b8860b] uppercase">Verified Official</span>
             </div>
          </div>
          
          <div className="flex flex-col items-center">
            <span className="text-lg font-bold text-gray-800 mb-0.5">{date || new Date().toLocaleDateString()}</span>
            <div className="w-32 border-b border-gray-400 mb-2" />
            <span className="text-xs font-bold text-gray-500 uppercase">Date of Issue</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Certificate;
